import s from './Button.scss';
import React from 'react';
import clsx from 'clsx';
import { ContentWithLoader } from '../ContentWithLoader/ContentWithLoader';
export const Button = _ref => {
  let {
    className,
    onClick,
    secondary,
    icon,
    iconButton,
    block,
    disabled,
    isLoading,
    rounded,
    style,
    size = 'medium',
    skin = 'standard',
    children,
    dataHook,
    noBounce,
    suffixIcon
  } = _ref;
  const isPrimary = !secondary;
  const hasLetterSpacingBounceEffect = isPrimary && typeof children === 'string';
  const getContent = () => {
    if (!hasLetterSpacingBounceEffect || noBounce) {
      return children;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: s.bouncyTextContainer
    }, /*#__PURE__*/React.createElement(ContentWithLoader, {
      isLoading: !!isLoading
    }, /*#__PURE__*/React.createElement("span", {
      className: s.bouncyText
    }, children), /*#__PURE__*/React.createElement("span", {
      className: s.bouncyTextSpacer
    }, children)));
  };
  return /*#__PURE__*/React.createElement("button", {
    disabled: disabled,
    className: clsx(s.button, className, {
      [s.secondary]: secondary,
      [s.primary]: isPrimary,
      [s.large]: size === 'large',
      [s.medium]: size === 'medium',
      [s.small]: size === 'small',
      [s.tiny]: size === 'tiny',
      [s.block]: block,
      [s.loading]: isLoading,
      [s.rounded]: rounded,
      [s.premium]: skin === 'premium',
      [s.ai]: skin === 'ai',
      [s.iconButton]: iconButton
    }),
    style: style,
    onClick: onClick,
    "data-hook": dataHook
  }, icon && /*#__PURE__*/React.cloneElement(icon, {
    className: clsx(icon.props.className, s.prefixIcon)
  }) || null, getContent(), suffixIcon && /*#__PURE__*/React.cloneElement(suffixIcon, {
    className: clsx(suffixIcon.props.className, s.suffixIcon)
  }) || null);
};
//# sourceMappingURL=Button.js.map